import React from 'react';
import PropTypes from 'prop-types';

import { ReactComponent as Vk } from 'icons/Socials/Vk.svg';
import { ReactComponent as Ok } from 'icons/Socials/Ok.svg';
import { ReactComponent as Fb } from 'icons/Socials/Fb.svg';
import { ReactComponent as Twitter } from 'icons/Socials/Twitter.svg';
import { ReactComponent as Instagram } from 'icons/Socials/Instagram.svg';

import SocialLink from 'styled/SocialLink';

import List from './List';

function SocialLinks(props) {
  return (
    <List>
      {props.socialLinks.map((socialLink) => {
        if (socialLink.provider === 'google') return null;
        if (!socialLink.socialLink) return null;

        return (
          <SocialLink
            key={socialLink.socialLink}
            href={socialLink.socialLink}
            rel="nofollow noopener"
            target="_blank"
          >
            {(socialLink.provider === 'vkontakte') && (<Vk />)}
            {(socialLink.provider === 'odnoklassniki') && (<Ok />)}
            {(socialLink.provider === 'facebook') && (<Fb />)}
            {(socialLink.provider === 'twitter') && (<Twitter />)}
            {(socialLink.provider === 'instagram') && (<Instagram />)}
          </SocialLink>
        );
      })}
    </List>
  );
}

SocialLinks.propTypes = {
  socialLinks: PropTypes.arrayOf(PropTypes.shape({
    provider: PropTypes.oneOf(['vkontakte', 'odnoklassniki', 'facebook', 'twitter', 'instagram', 'google']),
    socialLink: PropTypes.string,
  })),
};

SocialLinks.defaultProps = {
  socialLinks: [],
};

export default SocialLinks;
